// extracted by mini-css-extract-plugin
export var filterIncDec = "_3l-0";
export var leftBorder = "_3l-1";
export var rightBorder = "_3l-2";
export var stringInput = "_3l-3";